export const FeaturesCardsCarousel = (function () {
  let swiperInstance, prevButton, nextButton = null;
  let SELECTORS = null;

  function initSwiper() {
    const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
    prevButton = document.querySelector(SELECTORS.prevButton);
    nextButton = document.querySelector(SELECTORS.nextButton);

    if (!swiperWrapper || !prevButton || !nextButton) {
      console.error('Required elements not found');
      return null;
    } 

    // Initialize Swiper
    const swiper = new Swiper(SELECTORS.swiper, {
      slidesPerView: "auto",
      spaceBetween: 16,
      freeMode: false,
      slidesOffsetAfter: 16,
      navigation: {
        nextEl: SELECTORS.nextButton,
        prevEl: SELECTORS.prevButton,
      },
      watchOverflow: true,
    });

		swiperInstance = swiper;

    // Set initial state of buttons
    updateButtonsState();

    // Add event listeners to update button states when slides change
    swiper.on('slideChange', function () {
      updateButtonsState();
    });
    
        
    function setWrapperWidth() {
      const wrapperRect = swiperWrapper.getBoundingClientRect();
    	const wrapperBefore = wrapperRect.left;
      const carouselContainer = document.querySelector('#features-cards-section .features-cards-carousel-container')
      
      carouselContainer.style.width = `${window.innerWidth - wrapperBefore}px`;
      carouselContainer.style.minWidth = `${window.innerWidth - wrapperBefore}px`;
      carouselContainer.style.maxWidth = `${window.innerWidth - wrapperBefore}px`;

      swiperWrapper.style.width = `${window.innerWidth - wrapperBefore}px`;
      swiperWrapper.style.minWidth = `${window.innerWidth - wrapperBefore}px`;
      swiperWrapper.style.maxWidth = `${window.innerWidth - wrapperBefore}px`;
    }

    window.addEventListener('resize', setWrapperWidth);
    setWrapperWidth(); 
    
    // Add resize event listener separately
    //window.addEventListener('resize', () => {
    //  const newOffsetBefore = refContainer.getBoundingClientRect().left;
      // Check if Swiper instance exists and has a method to update params
    //  if (swiper && swiper.params) {
    //    swiper.params.slidesOffsetBefore = newOffsetBefore;
    //    swiper.update(); // Refresh Swiper
    //  }
    //});

    return swiper;
  }

  // Function to update button states
  function updateButtonsState() {
  	if (!prevButton || !nextButton) return;
    
    prevButton.style.opacity = swiperInstance.isBeginning ? '0.5' : '1';
    prevButton.style.pointerEvents = swiperInstance.isBeginning ? 'none' : 'auto'; 

		nextButton.style.opacity = swiperInstance.isEnd ? '0.5' : '1';
    nextButton.style.pointerEvents = swiperInstance.isEnd ? 'none' : 'auto';
  }

  // Public methods
  return {
    init: function(selectors) {
      SELECTORS = selectors;
     	document.addEventListener('DOMContentLoaded', function() {
				const swiperWrapper = document.querySelector(SELECTORS.swiperWrapper);
        swiperWrapper.style.gap = '0';
        
        // Initialize swiper
        initSwiper();
			});
    }
  };
})();
